module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("7r7D7"))).then(() => module.bundle.root('jnagv'));